<template>
  <sc-panel-navigator>
    <div class="row" style="padding: 5px">
      <div class="col-grow">
        <el-date-picker
            style="flex-grow: 1"
            v-model="workingDate"
            :picker-options="{firstDayOfWeek:1}"
            value-format="d/M/yyyy"
            format="dd/MM/yyyy"
            type="date"
            @input="getAllData"
            placeholder="Pick a day"></el-date-picker>
      </div>
      <div v-if="!logsMode" class="col">
        <!--        <q-btn icon="campaign"></q-btn>-->
        <q-fab
            style="float: right; "
            color="secondary"
            external-label
            padding="xs"
            icon="build"
            square
            direction="down"
        >
          <q-fab-action

              @click="reportRoutes()"
              square
              color="primary"
              external-label
              icon="campaign"
              label="Report to Drivers"
              label-position="left"/>
          <q-fab-action

              @click="downloadExcel()"
              square
              color="secondary"
              external-label
              icon="file_download"
              label="Download Excel"
              label-position="left"/>
          <q-fab-action

              @click="downloadExcel('kreta-transfers')"
              square
              external-label
              color="secondary"
              icon="file_download"
              label="Download MTS Excel"
              label-position="left"/>
          <q-fab-action
              @click="logsMode=!logsMode"
              square
              color="accent"
              external-label
              icon="history_toggle_off"
              label="Routes Log"
              label-position="left"/>
        </q-fab>
      </div>
      <div class="col" v-if="logsMode">
        <sf-button
            @click="logsMode=false"
            material="close"
            style="width: 1.2em;font-size: 0.9em"
            type="warning">Log
        </sf-button>
      </div>
    </div>

    <template v-if="!logsMode">

      <q-list
          :dark="themeCtx=='dark'"
          padding
          bordered
          class="rounded-borders"
          style="height: calc(100vh - 120px);">
        <q-expansion-item
            dense
            dense-toggle
            expand-separator
            icon="perm_identity"
            label="Drivers Swifts"
            v-model="driversPanel">
          <q-card
              :dark="themeCtx=='dark'"
              dense>
            <q-card-section
                :dark="themeCtx=='dark'"
                dense>
              <q-list
                  bordered
                  separator>
                <q-item>
                  <q-item-section>
                    <q-item-label caption>&nbsp;</q-item-label>

                  </q-item-section>
                  <q-item-section>
                    <!--                  <q-item-label-->
                    <!--                      caption-->
                    <!--                      v-for="dtl in drive.details" >{{ dtl }}-->
                    <!--                  </q-item-label >-->
                    <q-item-label

                    >

                      <span style="width:25%;float: left;font-size: 9px">M.P</span>
                      <span style="width:25%;float: left;font-size: 9px">M.T</span>
                      <span style="width:25%;float: left;font-size: 9px">D.T</span>
                      <span style="width:25%;float: left;font-size: 9px">D.P</span>
                    </q-item-label>
                  </q-item-section>
                </q-item>
                <q-item v-for="drive in swiftStats" xclick="handleMessages">
                  <q-item-section>
                    <q-item-label caption>{{ drive.driver }}</q-item-label>

                  </q-item-section>
                  <q-item-section>

                    <q-item-label>

                      <span style="width:25%;float: left">&nbsp;{{ drive.details['M.PICKUP'] }}</span>
                      <span style="width:25%;float: left">&nbsp;{{ drive.details['M.TRANSFER'] }}</span>
                      <span style="width:25%;float: left">&nbsp;{{ drive.details['D.TRANSFER'] }}</span>
                      <span style="width:25%;float: left">&nbsp;{{ drive.details['D.PICKUP'] }}</span>
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>
          </q-card>
        </q-expansion-item>

        <q-expansion-item
            dense-toggle
            dense
            expand-separator
            icon="directions_bus"
            label="Trip Selection"
            v-model="tripsPanel">
          <div
              :dark="themeCtx=='dark'"
              style="padding: 0px"
              v-fill-height>

            <bookings-selector
                :transfer-data="allLoadedRoutes"
                @select="workingCompany=$event.selected_companies;workingTrips=$event.selected_trips"
                route-data></bookings-selector>

          </div>

        </q-expansion-item>


      </q-list>
    </template>

    <el-card
        v-if="loaded"
        slot="body">
      <div
          slot="header"
          class="clearfix">

      </div>
      <div>

        <s-table
            ref="drafts"
            v-if="!logsMode&&workingDate"
            rowKeyField="id"
            :selectMode="true"
            @select="keepSelected"
            :pagging="1000"
            v-model="loadedRoutes"
            :mobileMode="isMobileDevice()"
            :colDefinitions="colDefinitions"
            key="q1"
            selectStorage="dailyRoutes"
            modx-processor="vue_route/transfers/getlist"
            :r-query="routesQuery"
            :lazyLoader="false"></s-table>
        <s-table
            key="ll"
            ref="logs"
            v-if="logsMode&&workingDate"
            rowKeyField="id"
            :selectMode="true"

            :pagging="1000"

            :mobileMode="isMobileDevice()"
            :colDefinitions="colDefinitions"

            modx-processor="vue_route/transfers/getlog"
            :r-query="{workingDate:workingDate,notincludecache:true,flatroutes:true,coids:workingCompany,workingTrips:workingTrips,trip_types:$route.params.trips}"
            :lazyLoader="false"></s-table>
        <el-drawer
            :size="isMobileDevice()?'100%':'70%'"
            title="I am the title"
            :visible.sync="displayBookings"
            direction="rtl"
            :modal-append-to-body="false"
            :with-header="false">
          <el-card>
            <div
                slot="header"
                class="clearfix">
              <el-row>
                <el-button
                    icon="el-icon-close"
                    circle
                    style="float: right;"
                    @click="displayBookings=false"></el-button>

                <el-button
                    title="Full pickup list"

                    style="float: left;"
                    type="success"
                    plain

                    @click='goPdf("transfers-ppprinter.html",{printimes:1,selectedRoutes:bookingsCom.routenum ,cooptions:""});'>
                  <i class="material-icons">print</i>
                </el-button>
              </el-row>
              <el-row v-if="availableCosOnRoute">
                <el-button-group>
                  <el-button
                      v-for="coDat in availableCosOnRoute"
                      @click="bookingsCom.coid=coDat.coid"
                      :key="coDat.coid"
                      :type="coDat.coid==bookingsCom.coid?'success':'default'">{{ coDat.coname }}({{ coDat.copax }})
                  </el-button>
                  <el-button
                      @click="bookingsCom.coid=null"
                      :disabled="!bookingsCom.coid">X
                  </el-button>
                </el-button-group>
              </el-row>
              <!--            <p>{{bookingsCom}}</p>-->
            </div>
            <el-row style="width: 100%">
              <s-table
                  ref="drafts"
                  v-if="displayBookings"
                  rowKeyField="id"

                  :pagging="1000"

                  :mobileMode="isMobileDevice()"
                  :colDefinitions="colBookingsDefinitions"
                  modx-processor="booking/getlist"
                  :r-query="bookingsCom"
                  :lazyLoader="false"


              ></s-table>
            </el-row>
          </el-card>

        </el-drawer>
      </div>
    </el-card>
  </sc-panel-navigator>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";
import STable from "../../Form/STable";
import * as moment from "moment";
import BookingsSelector from "../../Form/BookingsSelector";
import funs_transfers from "../../../mixins/funs_transfers";
import {fetchProcessor} from "../../../api/resource";

export default {
  components: {BookingsSelector, STable},
  mixins: [funs_transfers],
  data() {
    return {
      logsMode: false,
      loadedRoutes: null,
      allLoadedRoutes: null,
      // printData: null,
      // printReady: false,
      loaded: false,
      tripsPanel: true,
      driversPanel: false,
      selectedRoutes: null,
      displayBookings: false,
      availableCosOnRoute: null,
      routeList: null,
      locations: {},
      tourcompanies: {},
      fleet: null,
      swiftStats: null,
      workingCompany: [],
      workingTrips: [],
      bookingsCom: {limit: 0, sort: 'bookedTimeMM', routenum: null, coid: null}

      //
      // searchall: null,
      //
      // cols: {},
      // dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    ...mapActions({
      fetch: "tags/fetch",
      fetchAllOptions: "tags/fetchAll",
    }),
    async loadLogs() {
      const {data} = await api.fetchProcessor('vue_route/transfers/getlog', {
        workingDate: this.workingDate,
        notincludecache: true,
        flatroutes: true, limit: 0
      })

    },
    keepSelected(seldat) {
      if (!seldat || !seldat.length)
        this.selectedRoutes = null
      else
        this.selectedRoutes = seldat.map(bk => bk.routename)
      // _log_("hell.getAllData..", seldat);
    },
    async getAllData(dt) {
      if (!this.workingDate) return
      const stat = await api.fetchProcessor('contacts/stats', {workingDate: this.workingDate})
      if (stat.data && stat.data.results) {
        this.swiftStats = []

        Object.values(stat.data.results)
            .forEach(stat => {
              let details = {}
              if (stat.details.month) stat.details.month.forEach(dtl => details['M.' + dtl.rt_type] = dtl.rt_count)
              if (stat.details.day) stat.details.day.forEach(dtl => details['D.' + dtl.rt_type] = dtl.rt_count)
              this.swiftStats.push({driver: stat.driver, details: details})
            })
        _log_('    stat.data. this.swiftStats .', this.swiftStats)
      }
      const {data} = await api.fetchProcessor('vue_route/transfers/getlist', {
        workingDate: this.workingDate,
        notincludecache: true,
        flatroutes: true, limit: 0
      })

      this.allLoadedRoutes = data.results
    },
    async reportRoutes(routeO, publish_time = null) {
      _log_('this.$store.state.helpers.general_store[this.selectStorage])', routeO, this.$store.state.helpers.general_store['dailyRoutes'])
      let selected = routeO ? [routeO] : Object.values(this.$store.state.helpers.general_store['dailyRoutes'])
      if (selected?.length) selected = selected.map(r => r.routename)
      const {data} = await api.fetchProcessor('vue_route/transfers/getlist', {
        ...this.routesQuery,
        selectedRoutes: selected,
        _update: JSON.stringify({published_at: publish_time !== null ? publish_time : (new Date())})
      })
      if (!routeO) this.$refs.drafts.reload()
    },
    downloadExcel(type = 'transfers') {
      let selected = this.$store.state.helpers.general_store['dailyRoutes'] ? Object.values(this.$store.state.helpers.general_store['dailyRoutes']) : null
      if (selected?.length) selected = selected.map(r => r.routename)
      api.ajax_download("vue_booking/getlist", {
        routenum: this.selectedRoutes,
        coid: this.workingCompany,
        tripid: this.workingTrips,
        for: 'routing',
        filter_mode: this.$route.query.filter_mode,
        booking_filter: this.$route.query.booking_filter,
        plandate: this.workingDate,
        download: type,
        selectedRoutes: selected
      });
    },
    goDetails() {
    },
    // updateTable(msg) {
    //   _log_("hell.UPDATE..", msg);
    //   this.$refs.tourCoList.updateOrAppendRow(msg);
    // },
    async loadRoutes() {

      this.routeList = await api.getModxList('route', {workingDate: workingDate})
    },
  },
  async mounted() {
    const data = await api.getModxList('locations')
    if (data) {
      for (let i = 0; i < data.length; i++) {
        const ll = data[i]
        this.locations[ll.id] = ll
      }
    }
    // this.fleet = await api.getModxList('assets')
    await this.$store.dispatch('tags/fetch', 'assets')
    await this.$store.dispatch('tags/fetch', 'contacts')

    await this.fetchAllOptions('drivers')
    await this.getAllData()
    this.loaded = true;
    const tourcompanies = await this.$store.dispatch('tags/fetch', 'tourcompany')
    if (tourcompanies) {
      for (let i = 0; i < tourcompanies.length; i++) {
        const ll = tourcompanies[i]
        this.tourcompanies[ll.id] = ll
      }
    }
    // _log_("the rs///tourcompany///", tourcompany);
  },
  computed: {
    routesQuery() {

      return {
        workingDate: this.workingDate,
        notincludecache: true,
        flatroutes: true,
        coids: this.workingCompany,
        workingTrips: this.workingTrips,
        trip_types: this.$route.params.trips
      }
    },
    // pivotData() {
    //
    //   let allBks = []
    //   if (!this.loadedRoutes) return []
    //   this.loadedRoutes.forEach(rt => {
    //     if (!rt.bookings) allBks.push({flight: rt.flight, cocode: rt.rt_co_code, pax: rt.pax, routeNum: rt.routename})
    //     else allBks = allBks.concat(rt.bookings)
    //   })
    //   _log_('rt.bookings,', this.aggregateTransBookings(allBks, ['flight', 'cocode'],'items',true))
    //   return this.aggregateTransBookings(allBks, ['flight', 'cocode'],'items')
    // },
    workingDate:
        {
          get() {
            if (this.$route.query.workingDate) return this.$route.query.workingDate
            return moment()
                .format("DD/MM/YYYY")
          },
          set(v) {
            this.routeGo({query: {workingDate: v}})
            // return moment().format("DD/MM/YYYY")
          }
        },

    colBookingsDefinitions() {
      const domain = window.Travel.wdb
      // _log_('is...', domain)
      const cols = [


        {
          label: "Time",
          prop: "bookedTimeMM",
          width: '100px',

        },
        {
          label: "Type",
          prop: "tripType",
        },
        {
          prop: "flight",
          label: "Flight",
        },
        {
          prop: "meantype",

          label: "Trns.Type",
          formatter(val) {
            const options = {
              'shuttle': '<i class="material-icons" title="common shuttle">airport_shuttle</i>',
              "private": '<i class="material-icons"  title="private car">directions_car</i>',
              "private minibus": '<i class="material-icons"  title="private shuttle">directions_bus</i>',
              "direct": '<i class="material-icons" title="direct transfer">arrow_right_alt</i>',
              "notransfer": '<i class="material-icons" title="no transfer">directions_walk</i>'
            }
            return options[val] ? options[val] : ''
          }
        },
        {
          prop: "customer",
          label: "Customer",
        },
        {
          prop: "reference",
          label: "Reference",
        },
        {
          prop: "ppname",
          label: "Hotel",

        },

        {
          label: "V.Units",
          prop: "meanunits",
        },
        {
          label: "Adt",
          prop: "adults",
        },
        {
          label: "Kds",
          prop: "children",
        },
        {
          label: "Free",
          prop: "freePersons",
        },
        {
          label: "Inf.",
          prop: "infant",
        },

        {
          label: "Distributor",
          prop: "distributor",

        },

      ]
      // if( window.Travel.wdb =="travel_") cols.push
      return cols
    },
    colDefinitions() {
      const vm = this;
      const acts = {
        create: '<span class="material-icons" xstyle="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">add</span>',
        update: '<span class="material-icons" zstyle="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">edit</span>',
        remove: '<span class="material-icons" cstyle="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">delete</span>'
      }
      // _log_(">>>>>", this.invoiceData);
      if (this.logsMode) return [
        // {prop: "routename", width: "70px", editable: false, label: "Route"},
        {
          prop: "routename",
          width: "80px",

          formatter(val, props, row) {
            let c = (val * 1) % 128
            let o = "<div style='border-radius: 37%;text-align: center;padding:3px;background:rgb( " + (255 - c) + "," + c + "," + (200 - c) + ",0.6)'>" + val + "</div>"
            return o
          },
          label: "RN"

        },
        {
          prop: "action",
          width: "120px",


          label: "Action",
          formatter(val, props, row) {
            // return
            // return '<span class="material-icons">delete_forever</span>'
            return '<small style="color:' + (val == 'remove' ? 'red' : 'green') + '">' + acts[val] + '&nbsp;' + row.act_time + '</small>'
          }

        },
        {
          prop: "asset_id",
          width: "",
          formatter(val, props, row) {
            const vec = vm.findInArray(vm.$store.getters['tags/getList']('assets'), {id: row.asset_id})
            // _log_('vehicle...', vec,row)
            return (vec ? vec.name : '') + (row.driver_name ? '/' + row.driver_name : '')
          },

          // editable: true,
          sortable: true,
          // editorcomponentFactory(row) {
          //   // _log_('editorcomponentFactory...', row)
          //   return {
          //     is: "VehiclePicker",
          //     vehicleId: row.asset_id,
          //     contactId: row.driver_contact_id
          //   };
          // },
          label: "Vehicle"
        },

        // {
        //   prop: 'accepted_at',
        //   label: "accepted_at",
        //
        // },
        {
          // editable: true,
          prop: 'startTimeHuman',
          label: "Time",

        },
        {
          prop: 'details',
          label: "Trip",
          formatter(val, props, row) {
            val = val ? val : (row.bookings && row.bookings[0] ? row.bookings[0].tripType : null)

            if (val == 'DEP') val = '<i class="material-icons label-danger" style="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">flight_takeoff</i>'
            else if (val == 'ARV') val = '<i class="material-icons label-success" style="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">flight_land</i>'
            else val = '<i class="material-icons label-warning" style="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">directions_boat</i>'
            return (row['flight'] ? row['flight'] : row['gofor']) + ' ' + val;

          }
        },
        {
          prop: "real_loc_seq",
          width: "",

          label: "Route",
          formatter(val, props, row) {
            if (!val || !_.isArray(val)) return val
            let msg = []
            val.forEach(co => {
              msg.push('<span class="el-tag el-tag--info">' + vm.locations[co].code + '</span>')
            })


            return msg.join('')
          }
        },

        {
          prop: "coid",
          width: "",

          label: "Companies",
          formatter(val, props, row) {
            val = (val + '').split(',')
            let msg = []
            val.forEach(co => {
              msg.push('<span class="el-tag el-tag--info">' + (vm.tourcompanies[co].shortcode || vm.tourcompanies[co].coname)
                  + '</span>')
            })


            return msg.join('')
          }
        },

        // {
        //   prop: "routename",
        //   width: "80px",
        //
        //   formatter(val, props, row) {
        //     if (!row.bookings)
        //       return row.pax + '<span class="material-icons">directions_bus</span>'
        //     return row.pax + '<span class="material-icons">people</span><span class="material-icons">play_arrow</span>'
        //   },
        //
        //   label: "Bookings"
        //
        // },


      ];

      return [
        {
          label: "Active",
          prop: "published_at",
          width: '40px',
          // isClickable: true,
          // onClick(data) {
          //   this.$set(data, 'published_at', data.published_at ? 0 : (new Date()))
          //   vm.reportRoutes(data, data.published_at)
          //   _log_('onClick', data)
          // },
          formatter(val) {
            return val ? '<span class="material-icons" style="color: green">campaign</span>' : '<span class="material-icons" style="color: red">campaign</span>'
          }
        },
        {
          prop: "accepted_at", width: "70px",
          formatter(val, props, row) {
            let out = [], tm = ''
            if (!val) out.push('<i class="material-icons label-danger" style="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">info</i>')
            else {
              tm = new Date()
              tm.setTime(val * 1000)
            }
            out.push('<span class="small_note" title="' + tm.toString() + '">' + row.routename + '</span>')
            return out.join('')
          },
          editable: false, label: "Route"
        },
        {
          prop: "vehicleHandler",
          width: "",
          formatter(val, props, row) {
            const vec = vm.findInArray(vm.$store.getters['tags/getList']('assets'), {id: row.asset_id})
            // _log_('vehicle...', vec,row)
            return vec ? vec.name : ''
          },
          onChange(event, row) {
            _log_('vehicle...', event, row)
            vm.$set(row, 'asset_id', event.vehicleId)
            vm.$set(row, 'driver_contact_id', event.contactId)
            api.updateObject('vue_route', row)

          },
          // onlyEditMode: true,
          editable: true,
          sortable: false,
          editorcomponentFactory(row) {
            // _log_('editorcomponentFactory...', row)
            return {
              driversEnabled: false,
              is: "VehiclePicker",
              vehicleId: row.asset_id,
              contactId: row.driver_contact_id
            };
          },
          label: "Vehicle"
        },
        {
          prop: "driver_contact_id",
          width: "",
          formatter(val, props, row) {
            const vec = vm.findInArray(vm.$store.getters['tags/getList']('drivers'), {id: row.driver_contact_id})
            // _log_('vehicle...', vec,row)
            return vec ? vec.name : ''
          },
          onChange(event, row) {
            // _log_('vehicle...', event, row)
            // vm.$set(row, 'asset_id', event.vehicleId)
            // vm.$set(row, 'driver_contact_id', event)
            api.updateObject('vue_route', row)

          },
          // onlyEditMode: true,
          editable: true,
          sortable: false,
          editorcomponentFactory(row) {
            // _log_('editorcomponentFactory...', row)
            return {
              driversEnabled: false,
              is: "s-remote-select",
              classModel: 'contacts',
              labelProp: 'name',
              queryProp: 'search',
              prefixField: '_related',
              extraQueryParams: {forAsset: row.asset_id, type: 'driver'}
            };
          },
          label: "Driver"
        },
        //
        //     <s-remote-select
        //         dark
        //         style="width: 100%"
        //         v-model="tourcoselect"
        //         class-model="tourcompany"
        //         query-prop="q"
        //                 :multiple="true"
        // :extraQueryParams="{bookingRange:bookingRange,workingTripTypes:workingTripTypes}"
        //   label-prop="coname"
        //   placeholder="Company search..." ></s-remote-select >
        {
          editWhen(row) {

            // _log_(' editWhen(row)', row)
            return !row.bookings?.length
          },
          prop: 'startTimeHuman',
          label: "Time",
          editorcomponent: {
            is: "s-time",
            quasar: true

          },
          forwardEditOnChange: false,
          onChange(event, row) {

            vm.$set(row, 'startTimeMM', vm.strTimeToInt(event))

            api.updateObject('vue_route', row)

          },

        },
        {
          prop: 'details',
          label: "Trip",
          formatter(val, props, row) {
            val = val ? val : (row.bookings && row.bookings[0] ? row.bookings[0].tripType : null)

            if (val == 'DEP') val = '<i class="material-icons label-danger" style="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">flight_takeoff</i>'
            else if (val == 'ARV') val = '<i class="material-icons label-success" style="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">flight_land</i>'
            else val = '<i class="material-icons label-warning" style="color:white;text-align: center;margin-top: 7px;padding: 3px;border-radius: 37%;">directions_boat</i>'
            return (row['flight'] ? row['flight'] : row['gofor']) + ' ' + val;

          }
        },
        {
          prop: "locseq",
          width: "",

          label: "Route",
          formatter(val, props, row) {
            if (!row.bookings && !row.locseq) return
            let msg = []
            if (row.locseq_human) row.locseq_human.forEach(v => {
              msg.push('<span class="el-tag el-tag--info">' + v + '</span>')//class="el-badge__content el-badge__content--primary is-fixed"
            });
            else if (row.bookings) {
              const aggregatebks = vm.aggregateTransBookings(row, ['loc_code'])
              // _log_('val, props, row', aggregatebks, row)
              if (!aggregatebks) return


              aggregatebks.forEach(co => {
                msg.push('<span class="el-tag el-tag--info">' + co._id + '<span class="el-badge__content el-badge__content--warning">' + (co.pax) + '</span></span>')
              })
            }


            return msg.join('')
          }
        },

        {
          prop: "coid",
          width: "",

          label: "Companies",
          formatter(val, props, row) {
            if (!row.bookings && row.rt_co_code) return '<span class="el-tag el-tag--info">' + row.rt_co_code + '</span>'
            const aggregatebks = vm.aggregateTransBookings(row, ['cocode'])
            // _log_('val, props, row', aggregatebks, row)
            if (!aggregatebks) return


            var msg = []


            aggregatebks.forEach(co => {
              msg.push('<span class="el-tag el-tag--info">' + co._id + '<span class="el-badge__content el-badge__content--warning">' + (co.pax) + '</span></span>')
            })

            return msg.join('')
          }
        },

        {
          prop: "routename",
          width: "80px",
          isClickable: true,
          formatter(val, props, row) {
            if (!row.bookings)
              return row.pax + '<span class="material-icons">directions_bus</span>'
            return row.pax + '<span class="material-icons">people</span><span class="material-icons">play_arrow</span>'
          },
          enableClickCell(row) {
            return !!row.bookings//row.creation != 'manual'
          },
          onClick(row, event) {
            _log_('clll///', row, event)
            if (!row.bookings)
              return
            const co_data = vm.aggregateTransBookings(row.bookings, ['tourCoId'], 'items', true)
            _log_('editorcomponentFactory...', co_data)
            if (!co_data || !co_data.length) return;
            vm.availableCosOnRoute = co_data.map(bk => {
              return {
                coid: bk._id,
                copax: bk.pax,
                coname: bk._sample.cocode
              }
            })
            // _log_('editorcomponentFactory...', row, event)
            vm.bookingsCom.routenum = row.routename
            vm.bookingsCom.coid = null
            vm.displayBookings = true
            // _log_('clll///', row.routename, column, event)
            // vm.bookingList = []
            // api.getModxList('booking/getlist', { limit: 0, sort: 'bookedTimeMM', routenum: row.routename }, function (res) {
            //   if (res && res.results) {
            //     vm.selectedRoute = row.routename
            //     vm.bookingList = res.results
            //     vm.viewRoutes = false
            //   }
            //
            // })
          },
          label: "Bookings"

        },


      ];

    },
  },
};
</script>


<style>
.el-table td,
.el-table th {
  padding: 1px 0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-button {
  padding: 4px 10px 2px 10px;
}

/* .material-icons {
    font-size: 18px;
} */
.el-card__header {
  padding: 3px;
}

.el-menu-item {
  height: 40px !important;
  line-height: 30px !important;
}

/* .left_panel_heading BUTTON {
    width: 100%;
    border-right: #FFFFFF solid 1px;
    border-radius: 0px;
    text-align: left;
    margin-bottom: 0.5rem;
} */

.el-button.is-circle {
  padding: 4px 5px 2px 5px;
}

.left_panel_btn {
  display: flex;
  align-items: center;
}

.left_panel_btn SPAN {
  padding: 5px 8px 0px 8px;
  display: inline-block;
}

.selected_btn {
  border: 2px solid grey;
}

.cell {
  white-space: nowrap !important;
}

.clickable {
  background: #24af9e;
}
</style>
